"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const useQueryData_1 = require("./useQueryData");
function useGetKillEffectInfo() {
    return (0, useQueryData_1.default)('luckydraw', 'live.luckydraw.killEffectInfo');
}
exports.default = useGetKillEffectInfo;
